export default function hideBeforeMountLoader() {
  const loadingDiv = document.querySelector("#lc__loading");
  if (!loadingDiv) return;
  (loadingDiv as HTMLElement).style.display = "none";
}
